<template>
  <div class="dialog-area">
    <div class="dialog" v-if="show_dialog">
      <img v-if="show_img" class="gif" src="https://oss.mcloud.moveclub.cn/mcloudbkh5/20220922/1663844355-632c400389940.gif" />
      <div class="con" v-if="show_con">
        <img :src="`/img/title/${icon_step}.png`" class="title" />
        <div class="desc yasong">
          <div class="html" v-html="description"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (val) {
          this.show_dialog = val
          this.show_img = true

          setTimeout(() => {
            this.show_img = false
            this.show_con = true
          }, 2400)
        } else {
          this.show_dialog = val
          this.show_con = false
        }
      },
    },
  },
  props: {
    show: {
      default: false,
      type: Boolean,
    },
    icon_step: {
      default: false,
      type: Number,
    },
    description: {
      default: false,
      type: String,
    },
  },
  data() {
    return {
      show_dialog: false,
      show_img: false,
      show_con: false,
    }
  },
}
</script>

<style lang="less" scoped>
.dialog {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.16);
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  .gif {
    width: 500px;
    height: 500px;
  }
  .con {
    width: 626px;
    height: 554px;
    background: url(https://oss.mcloud.moveclub.cn/mcloudbkh5/20220922/1663826913-632bfbe14f64d.png) no-repeat center bottom / cover;
    border-radius: 40px;
    .title {
      width: 100%;
    }
    .desc {
      font-size: 22px;
      color: #573d18;
      line-height: 30px;
      font-weight: 400;
      padding: 0 15px;
      margin-top: 24px;
      text-align: justify;
      text-indent: 48px;
    }
  }
}
</style>
